import { Component, Input, OnInit } from '@angular/core';
import { SettingsService, _HttpClient } from '@delon/theme';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzResultModule } from 'ng-zorro-antd/result';
import { AuthService } from 'src/app/core/util/auth.service';
import { AppService } from 'src/app/shared/services/app.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-init-sample',
  templateUrl: './init-sample.component.html',
  styles: [],
  standalone: true,
  imports: [SharedModule, NzProgressModule, NzResultModule]
})
export class InitSampleComponent implements OnInit {
  visible = false;
  private _progress = 0;
  get progress() {
    return this._progress;
  }
  @Input() set progress(value: number) {
    this._progress = value;
    if (this._progress === 100) this.visible = false;
  }

  get company() {
    let company = this.settings.user['company'] ?? {};
    return company;
  }

  constructor(
    private readonly http: _HttpClient,
    private readonly auth: AuthService,
    private readonly settings: SettingsService,
    private readonly app: AppService
  ) {}

  ngOnInit(): void {
    const company = this.company;
    if (company?.isSample) {
      this.progress = company.initProgress;
      if (this.progress > 0 && this.progress < 100) this.visible = true;
      // if (!company.resetDaysLeft) {
      //   this.resetAndInit(company);
      // } else if (company.initProgress === 0) {
      //   this.visible = true;

      //   this.http.post('api/SampleData/Init').subscribe(res => {
      //     this.visible = false;
      //     this.app.forceReloadAndReturnHome();
      //   });
      // } else if (company.initProgress === 100) {
      //   this.visible = false;
      // }
    }
  }

  // resetAndInit(company: any) {
  //   this.http
  //     .post('api/SampleData/Reset', { tenantId: company.tenantId })
  //     .subscribe(res => {
  //       if (res?.tenantId) {
  //         this.auth.openCompany(res.tenantId);
  //       }
  //     });
  // }
}
